"use client"

import ContactModal from "@/components/ContactModal"
import { useState } from "react"
import Image from "next/image"

export function Hero({ isDynamicBooking = true }: { isDynamicBooking?: boolean }) {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false)

  const getNextMonth = () => {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const nextMonth = new Date()
    nextMonth.setMonth(nextMonth.getMonth() + 1)
    return months[nextMonth.getMonth()]
  }

  return (
    <section className="relative h-[821.594px] bg-black -mt-40 sm:mt-0 transition-all duration-500 ease-in-out">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src="/scaHome.jpeg"
          alt="Sovereign Creative Agency"
          fill
          priority
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
          className="object-cover object-[66%_center] sm:object-center"
          quality={85}
          loading="eager"
          placeholder="blur"
          blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkLzYvLy0vLzYvLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLz/2wBDAR0dHh4eHRoaHSQtJSEkLzYvLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLz/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
        />
      </div>
      
      {/* Add gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
      
      {/* Content Container */}
      <div className="relative z-10 mx-auto max-w-[110rem] px-4 sm:px-6 lg:px-10">
        <div className="h-[821.594px] flex items-end pb-16 md:pb-24 transition-all duration-500 ease-in-out">
          <div className="max-w-4xl space-y-4">
            <div className="flex flex-wrap items-center gap-2 text-sm">
              {isDynamicBooking && (
                <div className="relative mt-0 sm:mt-0">
                  <ContactModal
                    open={isBookingModalOpen}
                    onClose={() => setIsBookingModalOpen(false)}
                  >
                    <button 
                      onClick={() => setIsBookingModalOpen(true)}
                      className="relative bg-white/20 text-white px-4 py-2 rounded-md text-xs sm:text-sm backdrop-blur-sm inline-flex items-center gap-2 hover:bg-white/30 transition-colors"
                    >
                      <span className="h-2 w-2 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.6)] animate-pulse"></span>
                      Now booking projects for {getNextMonth()}
                    </button>
                  </ContactModal>
                </div>
              )}
            </div>
            <div className="space-y-4">
              <h1 className="font-bold uppercase text-[#f9fafb] text-4xl sm:text-5xl md:text-6xl" style={{ letterSpacing: '0.025em', lineHeight: '1.2', fontFamily: '"Universal Sans Display", -apple-system, Arial, sans-serif' }}>
                Your success,<br />is our success.
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-left leading-relaxed text-[#f9fafb]/90 max-w-2xl">
                Every brand has a story. We make yours unforgettable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}